var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M17.8571 -0.000183105H2.14286C0.959821 -0.000183105 0 0.959638 0 2.14267V17.857C0 19.04 0.959821 19.9998 2.14286 19.9998H17.8571C19.0402 19.9998 20 19.04 20 17.857V2.14267C20 0.959638 19.0402 -0.000183105 17.8571 -0.000183105ZM15.6741 7.0891C15.683 7.2141 15.683 7.34357 15.683 7.46857C15.683 11.3391 12.7366 15.7989 7.35268 15.7989C5.69196 15.7989 4.15179 15.3168 2.85714 14.4864C3.09375 14.5132 3.32143 14.5221 3.5625 14.5221C4.93304 14.5221 6.19196 14.0579 7.19643 13.2721C5.91071 13.2454 4.83036 12.4016 4.45982 11.2409C4.91071 11.3079 5.31696 11.3079 5.78125 11.1873C4.44196 10.915 3.4375 9.73642 3.4375 8.31232V8.2766C3.82589 8.49535 4.28125 8.62928 4.75893 8.64714C4.35733 8.38001 4.02812 8.01762 3.80066 7.5923C3.5732 7.16698 3.45457 6.69196 3.45536 6.20964C3.45536 5.665 3.59821 5.165 3.85268 4.73196C5.29464 6.50875 7.45982 7.66946 9.88839 7.79446C9.47321 5.80785 10.9598 4.19625 12.7455 4.19625C13.5893 4.19625 14.3482 4.54892 14.8839 5.12035C15.5446 4.99535 16.1786 4.74982 16.7411 4.415C16.5223 5.09357 16.0625 5.665 15.4554 6.0266C16.0446 5.9641 16.6161 5.79892 17.1429 5.57125C16.7455 6.15607 16.2455 6.67392 15.6741 7.0891Z",
    fill: "#021C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.46aae5475bdc630c06e27e814aceb341.svg";
export { ForwardRef as ReactComponent };